// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".open-pay-box-container[data-v-2ce13b49] {\n  max-width: 900px;\n  height: 90vh;\n}[dir] .open-pay-box-container[data-v-2ce13b49] {\n  margin: 0 auto;\n}\n.open-pay-box-form[data-v-2ce13b49] {\n  width: 350px;\n}\n.input-size[data-v-2ce13b49] {\n  font-size: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
